import { render, staticRenderFns } from "./user_cjhd.vue?vue&type=template&id=961aadd6&scoped=true"
import script from "./user_cjhd.vue?vue&type=script&lang=js"
export * from "./user_cjhd.vue?vue&type=script&lang=js"
import style0 from "./user_cjhd.vue?vue&type=style&index=0&id=961aadd6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961aadd6",
  null
  
)

export default component.exports